import React, {Component} from 'react';
import ArrowDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import ArrowUp from 'material-ui/svg-icons/navigation/arrow-drop-up';
import ArrowRight from 'material-ui/svg-icons/av/play-arrow';

const arrowStyles = {
  position: 'absolute',
  right: 0,
  top: 0
}
class TagInfoTable extends Component {
  constructor (props) {
    super(props);
    this.state = {
      activeIndex: 0,
      arrowActive: 'down'
    }
  }
  componentDidMount () {
  }
  handleClick (label, index) {
    this.setState({
      activeIndex: index
    });
    if (+index === this.state.activeIndex) {
      if (this.state.arrowActive === 'down') {
        this.setState({
          arrowActive: 'up'
        })
      } else {
        this.setState({
          arrowActive: 'down'
        })
      }
    } else {
      this.setState({
        arrowActive: 'down'
      })
    }
    if (index === 0) {
      this.props.handleSortByClientName()
    }
  }
  spreadTr (index) {
    if (this.state[`spread${index}`]) {
      this.setState({
        [`spread${index}`]: false
      })
    } else {
      this.setState({
        [`spread${index}`]: true
      });
    }
  }
  render () {
    return (
      <div className="tag-info-table">
        <table>
          <tbody>
            <tr>
              {this.props.tableHeaderArr.map((item, index) => {
                let widthStyle = '';
                switch (index) {
                  case 0:
                    widthStyle = '22%';
                    break;
                  case 1:
                    widthStyle = '15%';
                    break;
                  case 2:
                    widthStyle = '15%';
                    break;
                  case 3:
                    widthStyle = '18%';
                    break;
                  case 4:
                    widthStyle = '9%';
                    break;
                  case 5:
                    widthStyle = '9%';
                    break;
                  default:
                    widthStyle = '';
                    break;
                }
                return (
                  <th key={item.value}
                      className={this.state.activeIndex === index && index === 0 ? 'active' : ''}
                      onClick={() => {if (item.label === 'Client Name') this.handleClick(item.label, index)}}
                      style={{width: widthStyle}}
                  >
                    {item.label}
                    {
                      (
                        this.state.activeIndex === index &&
                        this.state.arrowActive === 'down' &&
                        index === 0
                      ) && (
                        <ArrowDown
                          style={{
                            ...arrowStyles
                          }}
                        />
                      )
                    }
                    {
                      (
                        this.state.activeIndex === index &&
                        this.state.arrowActive === 'up' &&
                        index === 0
                      ) && (
                        <ArrowUp
                          style={{
                            ...arrowStyles
                          }}
                        />
                      )
                    }
                  </th>
                )
              })}
            </tr>
            {
              this.props.bodyDataArr.map((item, index) => {
              if (!item.children) {
                return (
                  <tr key={index}>
                    {[
                    <td key={`${index}0`}>
                      {item.clientName}
                    </td>,
                    <td key={`${index}1`}>
                      {item.bizUnitName}
                    </td>,
                    <td key={`${index}2`}>
                      {item.deploymentType}
                    </td>,
                    <td key={`${index}3`}>
                      {item.domain}
                    </td>,
                    <td key={`${index}4`}>
                      {item.uuid}
                    </td>,
                    <td key={`${index}5`}>
                      {item.activeStatus}
                    </td>
                    ]}
                  </tr>
                )
              } else {
                let obj  = [];
                if (item.children.length > 1){
                  obj.push(
                    <tr key={index} onClick={() => this.spreadTr(index)}>
                      <td colSpan={this.props.tableHeaderArr.length} style={{paddingLeft: '20px', cursor: 'pointer'}}>
                        {
                          this.state[`spread${index}`] ? (
                            <ArrowDown
                              style={{position: 'absolute', left: '-7px', top: '2px'}}
                            />
                          ) : (
                            <ArrowRight
                              style={{position: 'absolute', left: '-5px', top: '6px', width: '16px', height: '16px'}}
                            />
                          )
                        }{item.clientName}
                      </td>
                    </tr>
                  );
                }
                for(let v of item.children) {
                  obj.push(
                    <tr style={{display: this.state[`spread${index}`] || item.children.length === 1 ? 'table-row' : 'none'}}>
                      <td style={item.children.length > 1 ? {paddingLeft: '49px'}: {}}>
                        {v.clientName}
                      </td>
                      <td>
                        {v.bizUnitName}
                      </td>
                      {/*<td>*/}
                        {/*{item.accountManager && item.accountManager.firstName} {item.accountManager && item.accountManager.lastName}*/}
                      {/*</td>*/}
                      <td>
                        {v.deploymentType}
                      </td>
                      <td>
                        {v.domain || v.campaignName}
                      </td>
                      <td className="uuid">
                        {v.uuid.substring(0,6) + '...'}
                        <div>
                          {v.uuid}
                        </div>
                      </td>
                      <td>
                        {v.activeStatus}
                      </td>
                    </tr>
                  )
                }

                return obj;
              }
            })}
          </tbody>

        </table>
      </div>
    )
  }
}

export default TagInfoTable;



// WEBPACK FOOTER //
// ./src/components/TagsInfo/tag-info-table.jsx